import Modernizr from 'modernizr';

Modernizr.addTest('mobilesafari', () =>
    /iP(ad|hone|od).+Version\/[\d.]+.*Safari/i.test(navigator.userAgent) && !window.MSStream,
);
